import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DiscountCode } from '@shared/models/data/DiscountCode';
import { DiscountCodeService } from '@shared/services/administration/discount-code.service';
import { AddDiscountCodeDialogComponent } from '../add-discount-code-dialog/add-discount-code-dialog.component';
import { ApplicationService } from '@shared/services/administration/application.service';
import { MemberApplicationType } from '@shared/models/data/MemberApplicationType';
import { EditDiscountCodeComponent } from '../edit-discount-code/edit-discount-code.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-discount-code-landing-page',
  templateUrl: './discount-code-landing-page.component.html',
  styleUrls: ['./discount-code-landing-page.component.scss']
})
export class DiscountCodeLandingPageComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['marketCode', 'effectiveBeginDate', 'effectiveEndDate',
    'description', 'flatDiscount', 'discountPercent', 'memberGroups', 'editButton', 'deleteButton'];
  dataSource = new MatTableDataSource<DiscountCode>();
  @ViewChild(MatSort) sort: MatSort;
  loading = false;

  constructor(
    private discountCodeService: DiscountCodeService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.getAllDiscountCodes();
  }

  ngAfterViewInit() {
  }

  getAllDiscountCodes() {
    this.loading = true;
    this.discountCodeService.getDiscountCodes()
      .pipe(
        finalize(() => {
          this.loading = false;
        })).subscribe({
          next: (x) => {
            this.dataSource.data = x;
            this.dataSource.sort = this.sort;
          },
          error: () => {
            alert("Problem in loading discount codes.");
          }
        });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddDiscountCodeDialogComponent, {
      width: '600px',
      height: '825',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    });
  }

  openEditDialog(discountCode: DiscountCode) {

    const dialogRef = this.dialog.open(EditDiscountCodeComponent, {
      width: '600px',
      height: '825',
      data: {
        discountCode: discountCode
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    })
  }

  openConfirmAlert(discountCode: DiscountCode) {
    const confirmed = confirm(`Are you sure you want to delete "${discountCode.marketCode}"?`);
    if (confirmed) {
      this.loading = true;
      this.discountCodeService.deleteDiscountCode(discountCode.id).pipe(
        finalize(() => {
          this.loading = false;
        }))
        .subscribe({
          next: () => {
            this.openSnackBar("Successfully deleted.");
            this.refresh();
          },
          error: (err) => {
            alert("Error on deleting.");
          }
        })
    }
  }

  refresh() {
    this.getAllDiscountCodes();
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "Dismiss", {duration: 3000});
  }

}
